(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    function initReadingProgress() {
  const progressBar = document.getElementById('reading-progress-bar');
  const content = document.getElementById('article-content');

  if (!progressBar || !content) {
    console.warn('Reading progress: elements not found');
    return;
  }

  function updateProgress() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const contentHeight = content.offsetHeight;
    const viewportHeight = window.innerHeight;

    if (contentHeight <= viewportHeight) {
      progressBar.style.transform = 'scaleX(1)';
      return;
    }

    let progress = (scrollTop / (contentHeight - viewportHeight)) * 100;
    progress = Math.min(Math.max(progress, 0), 100);
    progressBar.style.transform = `scaleX(${progress / 100})`;
  }


  window.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress);
  window.addEventListener('load', updateProgress);


  setTimeout(updateProgress, 100);   
}

document.addEventListener('DOMContentLoaded', initReadingProgress);
  } catch(e) { console.error(e); }
})();

})();
